exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  width: 200px;\n  background-color: #f1f1f1;\n}\n\nli a {\n  display: block;\n  color: #000;\n  padding: 8px 16px;\n  text-decoration: none;\n}\n\n/*li a.active {*/\n  /*background-color: #4CAF50;*/\n  /*color: white;*/\n/*}*/\n\nli a:hover {\n  background-color: #555;\n  color: white;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/src/app/verticalnav/verticalnav.component.css
// module id = ../../../../../src/app/verticalnav/verticalnav.component.css
// module chunks = 1